<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g clip-path="url(#clip0_1_2)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.667969 10C0.667969 4.84536 4.84665 0.666687 10.0013 0.666687C15.156 0.666687 19.3346 4.84537 19.3346 10C19.3346 15.1547 15.156 19.3334 10.0013 19.3334C4.84664 19.3334 0.667969 15.1547 0.667969 10ZM10.0013 2.66669C5.95121 2.66669 2.66797 5.94993 2.66797 10C2.66797 14.0501 5.95122 17.3334 10.0013 17.3334C14.0514 17.3334 17.3346 14.0501 17.3346 10C17.3346 5.94993 14.0514 2.66669 10.0013 2.66669Z" fill="#184495"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.66669C10.5523 5.66669 11 6.1144 11 6.66669V10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10V6.66669C9 6.1144 9.44772 5.66669 10 5.66669Z" fill="#184495"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9 13.3333C9 12.781 9.44772 12.3333 10 12.3333H10.0083C10.5606 12.3333 11.0083 12.781 11.0083 13.3333C11.0083 13.8856 10.5606 14.3333 10.0083 14.3333H10C9.44772 14.3333 9 13.8856 9 13.3333Z" fill="#184495"/>
        </g>
        <defs>
            <clipPath id="clip0_1_2">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconAlertOutline',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
